/**
 * @generated SignedSource<<ab2b3256aab7b3d4c03aeb6fd16cbe5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editLearnStartDateButton_TreeStateFragment$data = {
  readonly id: string;
  readonly startedAt: string;
  readonly " $fragmentType": "editLearnStartDateButton_TreeStateFragment";
};
export type editLearnStartDateButton_TreeStateFragment$key = {
  readonly " $data"?: editLearnStartDateButton_TreeStateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editLearnStartDateButton_TreeStateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editLearnStartDateButton_TreeStateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    }
  ],
  "type": "TreeState",
  "abstractKey": null
};

(node as any).hash = "1b625449d03d07e0ebccdea5aa6f40c3";

export default node;
